import { navLinks } from '@/mocks/home';

export default function SiteFooter() {
  const year = 2026;

  return (
    <footer className="bg-primary-950 px-4 py-14 text-background-100 md:px-8 md:py-16">
      <div className="mx-auto w-full max-w-6xl">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr] md:gap-12">
          <div>
            <div className="flex items-center gap-2 font-heading text-lg font-bold text-background-50 md:text-xl">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-group-line text-lg" aria-hidden="true"></i>
              </span>
              出轨同学会
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-200/80">
              一份围绕剧集《出轨同学会》整理的观剧参考，涵盖剧情脉络、角色关系、分集看点与主题解读。
              这里只提供内容层面的了解，不提供任何下载或在线播放入口。
            </p>
          </div>

          <nav aria-label="页脚导航">
            <h3 className="font-heading text-sm font-semibold text-background-50">内容导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.slice(0, 4).map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-200/80 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="页脚更多导航">
            <h3 className="font-heading text-sm font-semibold text-background-50">更多</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.slice(4).map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-200/80 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-6 text-background-200/70">
            本页内容为剧迷根据公开资料整理的一般性介绍，仅供观剧参考，具体以官方发布为准。
          </p>
          <p className="text-xs text-background-200/70">
            © {year} 出轨同学会 · 剧集资料整理
          </p>
        </div>
      </div>
    </footer>
  );
}